import React from 'react'
import PropTypes from 'prop-types'
import { Container } from './styles'

export default function DescList({ children }) {
  return (
    <Container>
      {children}
    </Container>
  )
}

DescList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
}
